import * as e from "react";
const t = (a) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...a
  },
  /* @__PURE__ */ e.createElement("g", { fill: "#2D6DED", clipPath: "url(#document-download_svg__clip0_1435_1597)" }, /* @__PURE__ */ e.createElement("path", { d: "M23.41 3L21 .59A2 2 0 0019.59 0H8a2 2 0 00-2 2v7.28a.26.26 0 00.24.25c.37 0 1 0 1.49.08A.25.25 0 008 9.36V2.5a.5.5 0 01.5-.5h10.88a.47.47 0 01.35.15l2.12 2.12a.47.47 0 01.15.35V18a.5.5 0 01-.5.5h-6.86a.25.25 0 00-.24.21 8.893 8.893 0 01-.4 1.46.24.24 0 00.23.33H22a2 2 0 002-2V4.41A2 2 0 0023.41 3z" }), /* @__PURE__ */ e.createElement("path", { d: "M6.5 11a6.5 6.5 0 106.5 6.5A6.51 6.51 0 006.5 11zm2.39 7.31l-2 2.5a.5.5 0 01-.78 0l-2-2.5a.51.51 0 01-.06-.53.5.5 0 01.45-.28h.88a.13.13 0 00.12-.12V14.5a1 1 0 112 0v2.88a.13.13 0 00.12.12h.88a.5.5 0 01.45.28.51.51 0 01-.06.53z" })),
  /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", { id: "document-download_svg__clip0_1435_1597" }, /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h24v24H0z" })))
);
export {
  t as default
};
